function parseGitUrl(url) {
  return url.split("url:")[1];
}

export { parseGitUrl };
//# sourceMappingURL=parseGitUrl.esm.js.map
